var CardBrand;
(function (CardBrand) {
    CardBrand["VISA"] = "VISA";
    CardBrand["MASTERCARD"] = "MASTERCARD";
    CardBrand["AMEX"] = "AMEX";
    CardBrand["DINERS_CLUB"] = "DINERS_CLUB";
    CardBrand["DISCOVER"] = "DISCOVER";
})(CardBrand || (CardBrand = {}));
var CardExpiryStatus;
(function (CardExpiryStatus) {
    CardExpiryStatus["OK"] = "ok";
    CardExpiryStatus["EXPIRING_SOON"] = "expiring_soon";
    CardExpiryStatus["EXPIRED"] = "expired";
})(CardExpiryStatus || (CardExpiryStatus = {}));
var isCard = function (method) { return Boolean(method) && typeof method === 'object' && 'cardBrand' in method; };

export { CardBrand, CardExpiryStatus, isCard };
